import Immutable, { Record } from 'immutable';

import { ApiResponseHelper } from 'omni-common-ui';

const ProgressReportRecord = Record({
  id: undefined,
  name: undefined,
  progressTestId: undefined,
  units: undefined,
  studentReportSummaries: ApiResponseHelper.create(),
  index: undefined,
});

class ProgressReport extends ProgressReportRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'id':
    case 'progressTestId':
      return [key, `${val}`]; // stringify
    default:
      return [key, Immutable.fromJS(val)];
  }
};

ProgressReport.create = (data) =>
  new ProgressReport(data).mapEntries(reviver);

export default ProgressReport;



// WEBPACK FOOTER //
// ./data/ProgressReports/model.js